import wrapper from 'wrapper';
import Scroller from '../scrolly-library/scroller';
import events from '../scrolly-library/events-emitter';
/* eslint-disable no-console */

class Scrolly {
    constructor() {
        this.scrolly = new Scroller({
            step: '.step',
            graphic: '.scroll__graphic', // this class, and the ones below, are in the scrolly library so shouldn't need changing
            container: '.scroll__container',
            textContainer: '.scroll__text',
            offset: this.setOffset(),
            debug: false, // defaults to false
        });
        this.animated = wrapper.select('#animation').checked;
        this.scrollyImage = wrapper.select('.scrolly-image');
        this.hideElementsBySelector('.layout-box');
        this.revealElementsBySelector('.step--1');
        this.locator = wrapper.select('.locator');
        this.locatorP = wrapper.select('.locator-player');
        this.particles = wrapper.selectAll('.particle-in');
        this.stepLastEntered = { element: wrapper.select('div.step'), index: 0, currentDirecton: 'down' };

        this.scrollyConfig = {
            scrollDown: [
                () => {
                    this.hideElementsBySelector('.step--1');
                    this.revealElementsBySelector('.step--2');
                },
                () => {
                    this.hideElementsBySelector('.step--2');
                    this.revealElementsBySelector('.step--3');
                },
                () => {
                    this.hideElementsBySelector('.step--3');
                    this.revealElementsBySelector('.step--4');
                },
                () => {
                    this.hideElementsBySelector('.step--4');
                    this.revealElementsBySelector('.step--5');
                },
                () => {
                    this.hideElementsBySelector('.step--5');
                    this.revealElementsBySelector('.step--6');
                    if(this.animated === true) {
                        this.locator.classList.add('animated');
                    } else {
                        this.locator.classList.remove('animated');
                    }
                },
                () => {
                    this.hideElementsBySelector('.step--6');
                    this.revealElementsBySelector('.step--7');
                    if(this.animated === true){
                        this.particlesReveal(7);
                    } else {
                        this.particlesHide(7);
                    }
                },
                () => {
                    this.hideElementsBySelector('.step--7');
                    this.revealElementsBySelector('.step--8');
                },
                () => {
                    this.hideElementsBySelector('.step--8');
                    this.revealElementsBySelector('.step--9');
                    if(this.animated === true) {
                        this.particlesReveal(9);
                    } else {
                        this.particlesHide(9);
                    }
                },
                () => {
                    this.hideElementsBySelector('.step--9');
                    this.revealElementsBySelector('.step--10');
                    if (this.animated === true) {
                        this.particlesReveal(10);
                    } else {
                        this.particlesHide(10);
                    }
                },
                () => {
                    this.hideElementsBySelector('.step--10');
                    this.revealElementsBySelector('.step--11');
                },
                () => {
                    this.hideElementsBySelector('.step--11');
                    this.revealElementsBySelector('.step--12');
                    if(this.animated === true) {
                        this.locatorP.classList.add('animated');
                    } else {
                        this.locatorP.classList.remove('animated');
                    }
                },
                () => {
                    this.hideElementsBySelector('.step--12');
                    this.revealElementsBySelector('.step--13');
                    if (this.animated === true) {
                        this.particlesReveal(13);
                    } else {
                        this.particlesHide(13);
                    }
                },
                () => {
                    this.hideElementsBySelector('.step--13');
                    this.revealElementsBySelector('.step--14');
                },
                () => {
                    this.hideElementsBySelector('.step--14');
                    this.revealElementsBySelector('.step--15');
                    if (this.animated === true) {
                        this.particlesReveal(15);
                    } else {
                        this.particlesHide(15);
                    }
                },
                () => {
                    this.hideElementsBySelector('.step--15');
                    this.revealElementsBySelector('.step--16');
                    if (this.animated === true) {
                        this.particlesReveal(16);
                    } else {
                        this.particlesHide(16);
                    }
                },
                () => {
                    this.hideElementsBySelector('.step--16');
                    this.revealElementsBySelector('.step--17');
                    if (this.animated === true) {
                        this.particlesReveal(17);
                    } else {
                        this.particlesHide(17);
                    }
                },
                () => {
                    this.hideElementsBySelector('.step--17');
                    this.revealElementsBySelector('.step--18');
                    if (this.animated === true) {
                        this.particlesReveal(18);
                    } else {
                        this.particlesHide(18);
                    }
                },
                () => {
                    this.hideElementsBySelector('.step--18');
                    this.revealElementsBySelector('.step--19');
                },
                () => {
                    this.hideElementsBySelector('.step--19');
                    this.revealElementsBySelector('.step--20');
                },
                () => {
                    this.hideElementsBySelector('.step--20');
                    this.revealElementsBySelector('.step--21');
                },
            ],
            scrollUp: [
                // This does not have to be the same as the 'scroll down' steps - sometimes you may need to do the opposite, such as reverse an animation
                () => {
                    this.revealElementsBySelector('.step--1');
                    this.hideElementsBySelector('.step--2');
                },
                () => {
                    this.revealElementsBySelector('.step--2');
                    this.hideElementsBySelector('.step--3');
                },
                () => {
                    this.revealElementsBySelector('.step--3');
                    this.hideElementsBySelector('.step--4');
                },
                () => {
                    this.revealElementsBySelector('.step--4');
                    this.hideElementsBySelector('.step--5');
                },
                () => {
                    this.revealElementsBySelector('.step--5');
                    this.hideElementsBySelector('.step--6');
                },
                () => {
                    this.revealElementsBySelector('.step--6');
                    this.hideElementsBySelector('.step--7');
                },
                () => {
                    this.revealElementsBySelector('.step--7');
                    this.hideElementsBySelector('.step--8');
                    if(this.animated === true){
                        this.particlesReveal(7);
                    } else {
                        this.particlesHide(7);
                    }
                },
                () => {
                    this.revealElementsBySelector('.step--8');
                    this.hideElementsBySelector('.step--9');
                },
                () => {
                    this.revealElementsBySelector('.step--9');
                    this.hideElementsBySelector('.step--10');
                    if (this.animated === true) {
                        this.particlesReveal(9);
                    } else {
                        this.particlesHide(9);
                    }
                },
                () => {
                    this.revealElementsBySelector('.step--10');
                    this.hideElementsBySelector('.step--11');
                },
                () => {
                    this.revealElementsBySelector('.step--11');
                    this.hideElementsBySelector('.step--12');
                },
                () => {
                    this.revealElementsBySelector('.step--12');
                    this.hideElementsBySelector('.step--13');
                },
                () => {
                    this.revealElementsBySelector('.step--13');
                    this.hideElementsBySelector('.step--14');
                    if (this.animated === true) {
                        this.particlesReveal(13);
                    } else {
                        this.particlesHide(13);
                    }
                },
                () => {
                    this.revealElementsBySelector('.step--14');
                    this.hideElementsBySelector('.step--15');
                },
                () => {
                    this.revealElementsBySelector('.step--15');
                    this.hideElementsBySelector('.step--16');
                    if (this.animated === true) {
                        this.particlesReveal(15);
                    } else {
                        this.particlesHide(15);
                    }
                },
                () => {
                    this.revealElementsBySelector('.step--16');
                    this.hideElementsBySelector('.step--17');
                    if (this.animated === true) {
                        this.particlesReveal(16);
                    } else {
                        this.particlesHide(16);
                    }
                },
                () => {
                    this.revealElementsBySelector('.step--17');
                    this.hideElementsBySelector('.step--18');
                    if (this.animated === true) {
                        this.particlesReveal(17);
                    } else {
                        this.particlesHide(17);
                    }
                },
                () => {
                    this.revealElementsBySelector('.step--18');
                    this.hideElementsBySelector('.step--19');
                    if (this.animated === true) {
                        this.particlesReveal(18);
                    } else {
                        this.particlesHide(18);
                    }
                },
                () => {
                    this.revealElementsBySelector('.step--19');
                    this.hideElementsBySelector('.step--20');
                },
                () => {
                    this.revealElementsBySelector('.step--20');
                    this.hideElementsBySelector('.step--21');
                },
            ],
        };

        // set up scroller events/callbacks
        events.on('step-enter', (interaction) => {
            this.handleStepEnter(interaction);
            this.stepLastEntered = interaction;
            wrapper.trackUserAction('scrolly step triggered', `step: ${interaction.index}, direction: ${interaction.currentDirection}`);
        });

        events.on('step-exit', (interaction) => {
            this.handleStepExit(interaction);
        });

        events.on('animation-toggled', (target) => {
            this.animated = target;
        });

        window.addEventListener('orientationchange', () => {
            // After orientationchange, add a one-time resize event - because orientation called before rotate has finished and dimensions updated
            const afterOrientationChange = () => {
                this.scrolly.offset = this.setOffset();
                this.scrolly.offsetVal = this.scrolly.setOffsetTrigger();
                this.scrolly.handleResize();
                this.handleStepEnter(this.stepLastEntered);
                window.removeEventListener('resize', afterOrientationChange);
            };
            window.addEventListener('resize', afterOrientationChange);
        });
    }

    setOffset() {
        return window.innerWidth < 700 ? 0.9 : 0.8;
    }

    handleStepEnter(interaction) {
        if (interaction.currentDirection === 'down' && interaction.index > 0) {
            this.scrollyConfig.scrollDown[interaction.index - 1]();
        }
        if (interaction.currentDirection === 'up' && interaction.index === this.scrollyConfig.scrollUp.length) {
            this.scrollyConfig.scrollUp[this.scrollyConfig.scrollUp.length - 1](); // trigger angie in her office on scroll back up (not correctly by the step exit handler)
        }
    }

    handleStepExit(interaction) {
        if (interaction.currentDirection === 'up' && interaction.index <= this.scrollyConfig.scrollUp.length) {
            if (interaction.index > 0) this.scrollyConfig.scrollUp[interaction.index - 1](); // temp fix to stop errors
        }
    }

    hideElementsBySelector(bo) {
        wrapper.selectAll(bo).forEach((element) => {
            element.classList.remove('visible');
        });
    }

    revealElementsBySelector(bo) {
        wrapper.selectAll(bo).forEach((element) => {
            element.classList.add('visible');
        });
    }

    particlesReveal(step) {
        const stepParticles = wrapper.selectAll(`.step--${step} .particle-in`);

        this.particles.forEach((p) => {
            if (stepParticles.includes(p)) {
                // Adds animated class to current step particles
                p.classList.add('particle-in-animated');
            }
            else {
                // Removes animated class from other step particles
                p.classList.remove('particle-in-animated');
            }
        });
    }

    particlesHide(step) {
        const stepParticles = wrapper.selectAll(`.step--${step} .particle-in`);

        this.particles.forEach((p) => {
            if (stepParticles.includes(p)) {
                // Removes animated class to current step particles
                p.classList.remove('particle-in-animated');
            }
            else {
                // Adds animated class from other step particles
                p.classList.add('particle-in-animated');
            }
        });
    }

    cancelAnimationsOnElt(elt) {
        const elementNode = elt;
        const containerElt = elementNode.parentNode;
        containerElt.removeChild(elementNode);
        containerElt.append(elementNode);
        return elementNode;
    }
}

export default Scrolly;
